<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!--ticket-duration.component.html-->
<!-- Input gets the error state look if invalid -->
<div class="wrap-relative">
	<error-pin
		class="l-drop-error-top-right"
		[messageHeader]="(errorState | async)?.messageHeader"
		[message]="(errorState | async)?.message"
		*ngIf="showErrorPin"
	></error-pin>
	<mat-form-field autocomplete="off" class="tiny-ticket-duration" subscriptSizing="dynamic">
		<mat-label>Days</mat-label>
		<input
			matInput
			novalidate
			disallowInput="^[0-9]*(\.[0-9]*)?$"
			type="number"
			[min]="minValue"
			[max]="maxValue"
			step="1.0"
			[formControl]="internalField"
			(focus)="internalFocused()"
			(blur)="internalBlurred()"
		/>
	</mat-form-field>
</div>
